module.exports = __webpack_public_path__ + "img/pro_two_5.7279e6ea.jpg";